import React, { useEffect } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import * as echarts from "echarts";

// eslint-disable-next-line import/no-extraneous-dependencies
import Styles from "../Reports.module.scss";

interface ChartProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any;
}
export default function Chart(props: ChartProps) {
    const ref = React.createRef<HTMLDivElement>();

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const chart = echarts.init(ref.current);
        chart.setOption(props.options);

        const handler = () => {
            chart.resize();
        };
        window.addEventListener("resize", handler);

        // eslint-disable-next-line consistent-return
        return () => {
            window.removeEventListener("resize", handler);
        };
    }, [ref, props.options]);

    return (<div ref={ref} className={`w-100 ${Styles["chart-1"]}`} />);
}
